import {
  Badge,
  CalendarMonth,
  ContactMail,
  Home,
} from "@mui/icons-material";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

export default function DrawerElement(props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer",
        paddingLeft: "20px",
      }}
    >
      {props.name === "Home" && (
        <Home
          sx={{ color: props.internal ? theme.palette.primary.main : "" }}
        />
      )}
      {props.name === "Kalender" && (
        <CalendarMonth
          sx={{ color: props.internal ? theme.palette.primary.main : "" }}
        />
      )}
      {props.name === "Kontakt" && (
        <ContactMail
          sx={{ color: props.internal ? theme.palette.primary.main : "" }}
        />
      )}
      {props.name === "Impressum" && (
        <Badge
          sx={{ color: props.internal ? theme.palette.primary.main : "" }}
        />
      )}
      <Box
        onClick={() =>
          (window.location.href =
            process.env.REACT_APP_FRONTEND_PREFIX + props.path)
        }
      >
        <Typography
          variant="body1"
          sx={{ color: props.internal ? theme.palette.primary.main : "" }}
          fontSize={24}
        >
          {props.name}
        </Typography>
      </Box>
    </Box>
  );
}
